import React, { useEffect, useState } from "react"
import { NavLink, useLocation } from "react-router"
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux'

import { TOGGLE_LEFT_MENU } from 'store/layout/actions'
import { store } from 'store/index'
import { hasPermission } from 'helpers/permissions'
//Import Scrollbar
import { exportMenu } from './menu'

/**
 * Меню под права администратора.
 *
 * Пункт без права не рисуем, а заголовок секции — только если под ним остался хотя бы
 * один пункт: иначе у продажника в сайдбаре висели бы пустые «Биллинг» и «Система».
 *
 * Элементы копируем: `exportMenu` — общий объект модуля, а компонент проставляет в нём
 * `active`.
 */
function buildMenu(account) {
	return exportMenu.map(group => {
		const children = (group.children || [])
			.filter(item => item.title || hasPermission(item.permission, account))
			.map(item => ({ ...item }))

		const visible = []

		for (let i = 0; i < children.length; i++) {
			if (children[i].title) {
				const next = children[i + 1]

				if (!next || next.title) {
					continue
				}
			}

			visible.push(children[i])
		}

		return { ...group, children: visible }
	})
}

function SidebarContent() {
	const { t } = useTranslation()
	const location = useLocation()
	const layoutSelector = useSelector(state => state.layout)
	const reduxAccount = useSelector(state => state.account)

	const [menu, setMenu] = useState(() => buildMenu(reduxAccount))
	const [activeItem, setActiveItem] = useState({
		children: []
	})

	function setActiveMenu(source = menu) {
		var menuCopy = [...source]
		for (let k = 0; k < menuCopy.length; k++) {
			for (let i = 0; i < menuCopy[k]['children'].length; i++) {
				if (menuCopy[k]['children'][i]['url'] && location.pathname.includes(menuCopy[k]['children'][i]['url'])) {
					menuCopy[k]['children'][i]['active'] = true;
					setActiveItem(menuCopy[k])
				} else {
					menuCopy[k]['children'][i]['active'] = false;
				}
			}
		}
		setMenu(menuCopy);
	}

	function setActiveChild(item, index) {
		store.dispatch(TOGGLE_LEFT_MENU(true))
		var copyArr = [...menu]
		const i = copyArr.findIndex(x => x.icon === activeItem.icon);
		copyArr[i]['children'][index].active = !copyArr[i]['children'][index].active
		setActiveItem(copyArr[i])
	}

	useEffect(() => {
		setActiveMenu()
	}, [location]) // eslint-disable-line react-hooks/exhaustive-deps

	// Права приезжают вместе с аккаунтом — при входе под другим администратором
	// меню пересобирается, а не остаётся от предыдущего.
	useEffect(() => {
		const nextMenu = buildMenu(reduxAccount)
		setActiveItem(nextMenu[0] || { children: [] })
		setActiveMenu(nextMenu)
	}, [reduxAccount]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className={"second-sidebar" + (layoutSelector.showleftMenu ? '' : ' d-none')}>
				<div id="sidebar-menu">
					<ul className="metismenu list-unstyled" id="side-menu">
						{activeItem.children.map((item, index) => (
							<li className={item.active ? "mm-active" : ""} key={index}>
								{item.title == null ?
									<NavLink to={item.url}
										onClick={() => setActiveChild(item, index)} className={"waves-effect d-flex " + (item.active ? "active" : "")}>
										<i className={item.icon}></i>
										<div className="vertical-menu-div">{t(item.i18n)}</div>
									</NavLink>
									:
									<div className="second-sidebar-title">
										<div>{t(item.i18n)}</div>
									</div>
								}
							</li>
						))}
					</ul>
				</div>
			</div>
		</>
	)
}

export default SidebarContent
